/**
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

import React from 'react';

import type { Property } from 'csstype';

import { Button, type ButtonProps } from '@mairistem/composants';

interface Props extends ButtonProps {
  /** May appears with a border. */
  active?: boolean;

  /** Button content */
  content?: React.ReactNode;

  /** Style to spread to the button. */
  style?: object;

  /** Text position. */
  textPosition: 'top' | 'right' | 'bottom' | 'left';

  /** Data test id */
  dataTestId?: string;

  /** Whether the button is disabled */
  disabled?: boolean;
}

const buttonFlexDirection: Record<string, Property.FlexDirection> = {
  top: 'column-reverse',
  right: 'row',
  bottom: 'column',
  left: 'row-reverse',
};

const ParametreButton = (props: Props) => {
  const {
    dataTestId = 'parametre-button',
    active = false,
    content = null,
    style = null,
    textPosition,
    disabled = false,
    ...rest
  } = props;

  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        flexDirection: buttonFlexDirection[textPosition],
      }}
    >
      <Button
        circular
        data-testid={dataTestId}
        {...rest}
        {...(disabled ? { onClick: null } : {})}
        style={{
          fontSize: '3rem',
          margin: '0.25em',
          border: '8px solid',
          borderColor: active ? 'transparent' : '#ebf2fa',
          ...(disabled ? { backgroundColor: 'grey', cursor: 'default' } : {}),
          ...style,
        }}
      />
      <h2 style={{ color: disabled ? 'grey' : undefined }}>{content}</h2>
    </div>
  );
};

export default ParametreButton;
